import React, { useEffect, useState } from 'react'
import {
  collection,
  getDocs,
  addDoc,
  serverTimestamp,
} from 'firebase/firestore'
import { db } from '../../firebaseConfig'
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage'

export default function NotifCleanerPage({ setActiveMenu }) {
  const [cleaners, setCleaners] = useState([])
  const [selectedTarget, setSelectedTarget] = useState('all_cleaners')
  const [title, setTitle] = useState('')
  const [message, setMessage] = useState('')
  const [imageFile, setImageFile] = useState(null)
  const [sending, setSending] = useState(false)

  const storage = getStorage()

  // ======================================================
  // 🔹 Ambil daftar cleaner dari Firestore
  // ======================================================
  useEffect(() => {
    const loadCleaners = async () => {
      const snap = await getDocs(collection(db, 'cleaners'))
      const list = snap.docs.map((d) => ({
        id: d.id,
        id_number: d.data().id_number,
        name: d.data().name || d.data().fullName || 'Tanpa Nama',
      }))
      setCleaners(list.sort((a, b) => a.name.localeCompare(b.name)))
    }
    loadCleaners()
  }, [])

  // ======================================================
  // 🖼 Upload gambar ke Firebase Storage (opsional)
  // ======================================================
  const uploadImage = async () => {
    if (!imageFile) return null
    const fileName = `notifications_photos/${Date.now()}_${imageFile.name}`
    const storageRef = ref(storage, fileName)
    await uploadBytes(storageRef, imageFile)
    return await getDownloadURL(storageRef)
  }

  // ======================================================
  // 📩 Kirim notifikasi ke Firestore
  // ======================================================
  const sendNotification = async () => {
    if (!title.trim() || !message.trim()) {
      alert('⚠️ Judul dan pesan wajib diisi.')
      return
    }

    setSending(true)
    try {
      const imageUrl = await uploadImage()

      const targets =
        selectedTarget === 'all_cleaners'
          ? cleaners.map((c) => c.id_number)
          : [selectedTarget]

      for (const target of targets) {
        await addDoc(collection(db, 'notifications'), {
          title,
          message,
          sender: 'Admin Zimo',
          target,
          timestamp: serverTimestamp(),
          ...(imageUrl && { imageUrl }),
        })
      }

      alert('✅ Notifikasi berhasil dikirim!')
      setTitle('')
      setMessage('')
      setImageFile(null)
      setSelectedTarget('all_cleaners')
    } catch (err) {
      console.error('❌ Gagal kirim notifikasi:', err)
      alert('Terjadi kesalahan saat mengirim notifikasi.')
    } finally {
      setSending(false)
    }
  }

  // ======================================================
  // 🧱 UI HALAMAN
  // ======================================================
  return (
    <div className="text-gray-200">
      {/* HEADER */}
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-2xl font-bold">🧹 Notifikasi Mitra Cleaner</h2>
        <button
          onClick={() => setActiveMenu('inbox')}
          className="px-4 py-2 bg-gray-800 hover:bg-gray-700 rounded-lg border border-gray-700 text-sm"
        >
          ◀ Kembali
        </button>
      </div>

      {/* FORM INPUT */}
      <div className="bg-gray-900 p-5 rounded-xl border border-gray-800 space-y-5">
        {/* TARGET */}
        <div>
          <label className="block text-gray-400 mb-1 font-medium">
            Kirim ke
          </label>
          <select
            value={selectedTarget}
            onChange={(e) => setSelectedTarget(e.target.value)}
            className="w-full p-2 bg-gray-800 border border-gray-700 rounded-lg text-white"
          >
            <option value="all_cleaners">Semua Cleaner</option>
            {cleaners.map((c) => (
              <option key={c.id} value={c.id_number}>
                {c.name} ({c.id_number})
              </option>
            ))}
          </select>
        </div>

        {/* TITLE */}
        <div>
          <label className="block text-gray-400 mb-1 font-medium">
            Judul Notifikasi
          </label>
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Contoh: Bonus Mingguan"
            className="w-full p-2 bg-gray-800 border border-gray-700 rounded-lg text-white"
          />
        </div>

        {/* MESSAGE */}
        <div>
          <label className="block text-gray-400 mb-1 font-medium">
            Isi Pesan
          </label>
          <textarea
            rows="4"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Tuliskan pesan yang ingin dikirim..."
            className="w-full p-2 bg-gray-800 border border-gray-700 rounded-lg text-white"
          ></textarea>
        </div>

        {/* IMAGE */}
        <div>
          <label className="block text-gray-400 mb-1 font-medium">
            Gambar (opsional)
          </label>
          <input
            type="file"
            accept="image/*"
            onChange={(e) => setImageFile(e.target.files[0])}
            className="w-full text-gray-400"
          />
          {imageFile && (
            <p className="text-xs text-green-400 mt-1">
              📸 {imageFile.name} siap diunggah
            </p>
          )}
        </div>

        {/* BUTTON */}
        <button
          disabled={sending}
          onClick={sendNotification}
          className={`w-full py-3 rounded-lg font-semibold ${
            sending
              ? 'bg-gray-700 cursor-not-allowed'
              : 'bg-green-600 hover:bg-green-700'
          }`}
        >
          {sending ? 'Mengirim...' : 'Kirim Notifikasi'}
        </button>
      </div>
    </div>
  )
}
